import apiClient from "./base/apiClient";

/** 한 사람의 축 분포. counts는 axes와 같은 라벨을 키로 갖는다. */
export interface TasteSide {
  /** 기록을 남긴 장소 수. 결과를 보여줄지 말지를 이 값으로 가른다 */
  total: number;
  counts: Record<string, number>;
  nickname: string;
  profile_image: string | null;
}

export interface TasteProfile {
  similarity: number;
  /** 양쪽 모두 이만큼은 기록해야 결과를 보여준다. 기준은 서버가 정한다 */
  min_records: number;
  /** 머리말 한 줄 — 서버가 규칙으로 고른다 */
  headline: string;
  /** 근거 세 문장. 항상 정확히 3개 */
  lines: string[];
  /** 축 순서. 누구를 보든 고정 */
  axes: string[];
  target: TasteSide & { id: string };
  me: TasteSide;
}

/** 취향 유사도 분석 — 프로필의 "나와의 유사도"를 눌렀을 때 */
export const getTasteProfile = async (
  userId: string
): Promise<TasteProfile> => {
  const res = await apiClient.get(`/user/${userId}/taste-profile`);
  return res.data;
};
